import React from 'react'

import { Grid } from '@mui/material'
import CustomInpuText from '../../customInputText/CustomInputText'
import PrimaryButton from '../../primaryButton/PrimaryButton'

import { useStyles } from './styles'
import Indicators from '../../indicators/Indicators'
import useValidation from '../../../hooks/useValidation'
import YesyNoRadioGroup from '../../yesNoRadioGroup/YesNoRadioGroup'

const Step3 = ({
  btnAction,
  handleGoto,
  handleChange,
  data,
  cantItems,
  current,
}) => {
  const classes = useStyles()

  const validationsSchema = {
    whatDidLike: {
      valid: data.whatDidLike || false,
      errorMsg: 'Please fill this field.',
      validate: (v) => v || false,
    },
    whatImprove: {
      valid: data.whatImprove || false,
      errorMsg: 'Please fill this field.',
      validate: (v) => v || false,
    },
    recomendWhy: {
      valid: data.recomendWhy || false,
      errorMsg: 'Please fill this field.',
      validate: (v) => v || false,
    },
  }

  const { errors, validate, validateAll } = useValidation(validationsSchema)

  const handleInternalChange = (evt) => {
    const { name, value } = evt.target
    handleChange(evt)
    validate(name, value)
  }

  const handleInternalBtnAction = (evt) => {
    if (validateAll()) {
      btnAction(evt)
    }
  }

  const handleInternalGoto = (index) => {
    if (index < data.step || validateAll()) {
      handleGoto(index)
    }
  }

  return (
    <Grid container spacing={2} className={classes.wrapper}>
      <Grid item xs={12}>
        <div className='static-label-wrapper'>
          <p className='static-label'>
            What has been the best part about working with Seacrest Services?
          </p>
        </div>
        <CustomInpuText
          placeholder='Type your answer...'
          multiline
          rows={3}
          required
          name='whatDidLike'
          value={data.whatDidLike}
          onChange={handleInternalChange}
          error={errors?.whatDidLike ? true : false}
          helperText={errors?.whatDidLike || 'max 4000 characters'}
          inputProps={{maxLength:4000}}
        />
      </Grid>
      <Grid item xs={12}>
        <div className='static-label-wrapper'>
          <p className='static-label'>
            Where does Seacrest Services have an opportunity to improve?
          </p>
        </div>
        <CustomInpuText
          placeholder='Type your answer...'
          multiline
          rows={3}
          required
          name='whatImprove'
          value={data.whatImprove}
          onChange={handleInternalChange}
          error={errors?.whatImprove ? true : false}
          helperText={errors?.whatImprove || 'max 4000 characters'}
          inputProps={{maxLength:4000}}
        />
      </Grid>
      <Grid item xs={12}>
        <div className='static-label-wrapper'>
          <p className='static-label'>
            Would you recommend our services for another Condominium or
            Homeowner Association Community? Why? Why not?
          </p>
        </div>
        <CustomInpuText
          placeholder='Type your answer...'
          multiline
          rows={3}
          required
          name='recomendWhy'
          value={data.recomendWhy}
          onChange={handleInternalChange}
          error={errors?.recomendWhy ? true : false}
          helperText={errors?.recomendWhy || 'max 4000 characters'}
          inputProps={{maxLength:4000}}
        />
      </Grid>
      <Grid item xs={12}>
        <YesyNoRadioGroup
          title='Would you like to be contacted by a member of our Management team?'
          name='wantBeContactedByManagers'
          value={data.wantBeContactedByManagers}
          onChange={handleInternalChange}
        />
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='center'
        alignItems='flex-end'
        sx={{ display: { sm: 'none', xs: 'flex' } }}
      >
        <Indicators cantItems={cantItems} current={current} handleGoto={handleInternalGoto} />
      </Grid>
      <Grid item xs={12} sm={6} lg={6} className={classes.btnWrapper}>
        <PrimaryButton onClick={handleInternalBtnAction}>Next</PrimaryButton>
      </Grid>
      <Grid
        container
        item
        xs={12}
        sm={6}
        lg={6}
        justifyContent='flex-end'
        alignItems='flex-end'
        sx={{ display: { sm: 'flex', xs: 'none' } }}
      >
        <Indicators
          cantItems={cantItems}
          current={current}
          handleGoto={handleInternalGoto}
        />
      </Grid>
    </Grid>
  )
}

export default Step3
